// @flow
import React from 'react';
import GrayBox from '../GrayBox';

type GrayBoxesProps = {
  countMin: number,
  countMax: number,
  sizeMin?: number,
  sizeMax?: number,
};

const GrayBoxes = ({ countMin, countMax, sizeMin, sizeMax }: GrayBoxesProps) => {
  const count = countMin + Math.ceil(Math.random() * (countMax - countMin));
  const array = Array.from(Array(count).keys());
  return array.map(num => <GrayBox key={num} min={sizeMin} max={sizeMax} />);
};

export default GrayBoxes;



// WEBPACK FOOTER //
// ./src/components/common/GrayBoxes/GrayBoxes.js